import { useMutation, useQueryClient } from "@tanstack/react-query";
import post from "./post";
import { dangerMessage } from "../components/Toast/Toast";
function useCustomMutation(key) {
  const queryClient = useQueryClient();

  return useMutation(
    (data) =>
      post(
        data.endPoint,
        data.bodyContent,
        data.Method,
        data.displayMessage,
        data.token,
        data.isJSON
      ),
    {
      onSuccess: (result) => {
        // Only invalidate queries if the operation was successful
        // The post function returns the result, which may contain error status
        if (result?.status === "success") {
          queryClient.invalidateQueries(key);
        }
        // If result has error status, it will be handled by the post function's error messages
      },
      onError: (error) => {
        //network error
        console.error("useCustomMutation error:", error);
        //dangerMessage("Oops! your internet is not working");
      },
    }
  );
}
export default useCustomMutation;
